import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 9.1 — Tour del Inventario del Día.
 * Sprint 26 — Reescrito tras Sprint 15 (rediseño a cards) y Sprint 25 (precarga).
 *
 * Cubre el flujo actual: grid de cards por insumo con semáforo, filtros
 * rápidos, precarga automática del día y histórico trazable.
 */
export const tourInventario: TourDefinition = {
  id: 'inventario',
  title: 'Cómo cargar el inventario',
  steps: [
    {
      element: '[data-tour="inv-header"]',
      popover: {
        title: '1. Inventario del día',
        description:
          'En esta pantalla controlas el stock de tus insumos (carne, pan, refrescos, etc.). Cada tarjeta es un insumo con su semáforo de stock.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="inv-precarga"]',
      popover: {
        title: '2. Precargar día (recomendado en la mañana)',
        description:
          'Este botón abre un wizard que sugiere cuánto cargar de cada insumo basado en lo vendido ayer. Te ahorra capturar uno por uno.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="inv-filtros"]',
      popover: {
        title: '3. Filtros rápidos por semáforo',
        description:
          'Toca un chip para filtrar: 🔴 Críticos (al límite o por debajo), 🟡 Bajos, ⚫ Agotados, 🟢 OK. Usa el buscador para hallar uno por nombre.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="inv-tabla"]',
      popover: {
        title: '4. Tarjetas por insumo',
        description:
          'Cada tarjeta muestra el stock crudo, cuánto puedes vender (después de merma) y si ya cargaste hoy. Toca "Agregar más stock" cuando recibas más mercancía.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="inv-historico"]',
      popover: {
        title: '5. Histórico del día',
        description:
          'Despliega esta sección para ver qué se cargó/vendió/mermó cada día. Útil para comparar entre fechas o conversar con tu proveedor.',
        side: 'top',
      },
    },
  ],
};
